import React, { Component, PropTypes } from 'react'

import EventListItem from './event-list-item'

class EventListItemContainer extends Component {

  constructor(props) {
    super(props)

    this.handleCardClick = this.handleCardClick.bind(this)
    this.handleLinkClick = this.handleLinkClick.bind(this)
  }

  handleCardClick() {
    if (this.context && this.context.router) {
      this.context.router.push(this.props.eventUrl)
    }
  }

  handleLinkClick(e) {
    e.stopPropagation()
  }

  render() {
    return (
      <EventListItem
        {...this.props}
        onCardClick={this.handleCardClick}
        onLinkClick={this.handleLinkClick}
      />
    )
  }
}

EventListItemContainer.contextTypes = {
  router: React.PropTypes.object,
}

EventListItemContainer.propTypes = {
  addNewDatesUrl: PropTypes.string,
  eventUrl: PropTypes.string,
}

export default EventListItemContainer



/** WEBPACK FOOTER **
 ** ./src/components/event-list-item/event-list-item-container.js
 **/